import { render } from "./PlayerView.vue?vue&type=template&id=96a29eb8&ts=true"
import script from "./PlayerView.vue?vue&type=script&lang=ts"
export * from "./PlayerView.vue?vue&type=script&lang=ts"

import "./PlayerView.vue?vue&type=style&index=0&id=96a29eb8&lang=scss"

import exportComponent from "C:\\Projekty\\VideoPLayer\\player\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__